import React, { useState, useEffect } from 'react';
import { Globals as OldGlobals } from '../../global/Globals';
import DropdownList from '../../components/DropdownList/DropdownList';
import FileUploader from '../../components/FileUploader/FileUploader';
import TextArea from '../../components/TextArea/TextArea';
import './CreateUnsolicited.css';
import { useDispatch, useSelector } from 'react-redux';
import { setAllChannels, setAllGeners, setAllLanguages, setAllCountries, setUSPScriptTypes, setAllChannelsByClusterId } from '../SignUp/ProducerRegistrationSlice';
import { fetchAllCountries, fetchAllFormats, fetchByfilter, fetchChannelsByCountry, fetchClustersByCountryAndScript, fetchGenresByCluster, fetchLanguagesByChannel, fetchScriptTypesByCountry,fetchAllProduction, fetchChannelbyClusters } from '../../services/GenericAPI';
import { useNavigate } from 'react-router-dom';
import GenericHeader from '../../components/GenericHeader/GenericHeader';
import blueInfoIcon from '../../assets/images/icons/info-blue.svg';
import infoIcon from '../../assets/images/icons/information-line.svg';
import UnsolicitedCreateFooter from '../../components/UnsolicitedCreateFooter/UnsolicitedCreateFooter';
import PopUp from '../../components/PopUp/PopUp';
import Unsolicited from './UnsolicitedHooks';
import { useLocation } from "react-router-dom";
import Loader from '../../components/Loader/Loader';
import CustomTooltip from '../../components/ToolTip/CustomTooltip'; 
import ProgressLoader from '../../components/ProgressLoader/ProgressLoader';
import { useLanguage } from '../../context/Languagecontext';
import FallBackLabel from '../../global/Globals_Eng.json';
import { formatCurrency } from '../../util/util';

let
    languageIds = {},
    genreIds = {},
    channelIds = {},
    countryIds = {},
    formatIds = {},
    currencyIds = {},
    clusterIds = {},
    productionTypeIds = {},
    targetAudienceIds = {},
    scriptTypesIds={},
    fieldNames={};

function nameToIdMap(arr, key = 'name',id="id") {
    const rv = {};
    for (let i = 0; i < arr.length; ++i){
        rv[arr[i][key]] = arr[i][id];
    }
    return rv;
}
const CreateUnsolicited = () => {
    const { Globals } = useLanguage();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [proposalTitle, setProposalTitle] = useState('');
    const [productionType, setProductionType] = useState('');
    const [touched, setTouched] = useState({
        productionType: false,
    });
    const [channel, setChannel] = useState('');
    const [country, setCountry] = useState('');
    const [scriptedUnscripted, setScriptedUnscripted] = useState('');
    const [currency, setCurrency] = useState('');
    const [genre, setGenre] = useState('');
    const [cluster, setCluster] = useState('');
    const [language, setLanguage] = useState('');
    const [targetAudience, setTargetAudience] = useState('');
    const [format, setFormat] = useState('');
    const [duration, setDuration] = useState('');
    const [noOfEpisodes, setNoOfEpisodes] = useState('');
    const [noOfMiniEpisodes, setNoOfMiniEpisodes] = useState('');
    const [episodeDuration, setEpisodeDuration] = useState('');
    const [episodeMiniDuration, setEpisodeMiniDuration] = useState('');
    const [synopsis, setSynopsis] = useState('');
    const [logline, setLogline] = useState('');
    const [targetBudget, setTargetBudget] = useState('');
    const [productionSchedule, setProductionSchedule] = useState('file');
    const [episodeStructureOutline, setEpisodeStructureOutline] = useState('');
    const [locationStudioInfo, setLocationStudioInfo] = useState('');
    const [castPresenterInfo, setCastPresenterInfo] = useState('');
    const [brandIntegrationOpportunities, setBrandIntegrationOpportunities] = useState('');
    const [projectStatus, setProjectStatus] = useState('');
    const [keyTeam, setKeyTeam] = useState('');
    const [artistName, setArtistName] = useState('');
    const [songName, setSongName] = useState('');
    const [socialLinks, setSocialLinks] = useState(['']);
    const [Formats, setAllFormats] = useState([]);
    const [Clusters, setAllClusters] = useState([]);
    const [ProductionTypes, setAllProductionTypes] = useState([]);
    const [TargetAudiences, setAllTargetAudiences] = useState([]);
    const [Currencies, setAllCurrencies] = useState([]);
    const [totalDuration, setTotalDuration] = useState('');
    const [totalMiniDuration, setTotalMiniDuration] = useState('');
    const [formatTypes, setFormatTypes] = useState({});
    const [AllScriptTypes, setAllScriptTypes] = useState([]);
    const [newGenreFlag, setNewGenreFlag] = useState(false);
    const [productionTypeFull, setproductionTypeFull] = useState([]);
    const [isMusicVideo, setIsMusicVideo] = useState(false);
    const [isBrandIntegrationOpportunities, setIsBrandIntegrationOpportunities] = useState(false);
    const [isEpisodeStructure, setIsEpisodeStructure] = useState(false);
    const [newGenre, setNewGenre] = useState("");
    const [proposalData,setProposalData]=useState({});
    const [isFormValid, setIsFormValid] = useState(false);
    const allChannelsData = useSelector(state => state.producerRegistration.allChannelsByClusterId).map(ele => ele.name);
        const allChannelsDetails = useSelector(state => state.producerRegistration.allChannelsByClusterId);
    //const allChannelsData = useSelector(state => state.producerRegistration.allChannels).map(ele => ele.channelName);
    const allLanguagesData = useSelector(state => state.producerRegistration.allLanguages.map(ele => ele.languageName));
    const allCountriesData = useSelector(state => state.producerRegistration.allCountries.map(ele => ele.countryName));
    const allGenersData = useSelector(state => state.producerRegistration.allGeners.map(genre => genre.genreName));
    const scriptData= useSelector(state => state.producerRegistration.uspScriptTypes);
    const location = useLocation();
    const [videoFile,setVideoFile]=useState(null);
    const [pdfFile,setPdfFile]=useState(null)
    const [isSeriesEpisodesValidMessage, setIsSeriesEpisodesValidMessage] = useState('');
    const [isMiniSeriesEpisodesValidMessage, setIsMiniSeriesEpisodesValidMessage] = useState('');
    const hooksProps = {
        proposalTitle,
        productionType,
        channel,
        totalDuration,
        totalMiniDuration,
        scriptedUnscripted,
        genre,
        videoFile,
        pdfFile,
        newGenre,
        cluster,
        country,
        language,
        targetAudience,
        format,
        duration,
        noOfEpisodes,
        noOfMiniEpisodes,
        projectStatus,
        episodeDuration,
        episodeMiniDuration,
        synopsis,
        logline,
        currency,
        targetBudget,
        productionSchedule,
        episodeStructureOutline,
        locationStudioInfo,
        castPresenterInfo,
        brandIntegrationOpportunities,
        keyTeam,
        artistName,
        songName,
        socialLinks,
        languageIds,
        genreIds,
        channelIds,
        countryIds,
        formatIds,
        currencyIds,
        clusterIds,
        productionTypeIds,
        targetAudienceIds,
        formatTypes,
        scriptTypesIds,
        proposalId:proposalData?.proposalId || "",
        proposalDetailId:proposalData?.proposalDetailId || ""
    };
    const [values, setValues] = useState({
        duration: duration,
        noOfEpisodes: noOfEpisodes,
        episodeDuration: episodeDuration,
        totalDuration:totalDuration,
        noOfMiniEpisodes: noOfMiniEpisodes,
        episodeMiniDuration: episodeMiniDuration,
        totalMiniDuration: totalMiniDuration
              });
        const error={proposalTitle:Globals.UNSOLICITED_ERROR_MSG.PROPOSALTITLE,
              synopsis:Globals.UNSOLICITED_ERROR_MSG.SYNOPSIS,
              logline:Globals.UNSOLICITED_ERROR_MSG.LOGLINE,
             episodeStructureOutline:Globals.UNSOLICITED_ERROR_MSG.EPISODESTRUCTUREOUTLINE,
              locationStudioInfo:Globals.UNSOLICITED_ERROR_MSG.LOCATIONSTUDIOINFO,
              castPresenterInfo:Globals.UNSOLICITED_ERROR_MSG.CASTPRESENTERINFO,
              brandIntegrationOpportunities:Globals.UNSOLICITED_ERROR_MSG.BRANDINTEGRATIONOPPORTUNITIES,
              keyTeam:Globals.UNSOLICITED_ERROR_MSG.KEYTEAM,
              newGenre:Globals.UNSOLICITED_ERROR_MSG.NEWGENRE,
              targetBudget:Globals.UNSOLICITED_ERROR_MSG.TARGETBUDGET,
              country:Globals.UNSOLICITED_ERROR_MSG.COUNTRY,
              scriptedUnscripted:Globals.UNSOLICITED_ERROR_MSG.SCRIPTEDUNSCRIPTED,
              genre:Globals.UNSOLICITED_ERROR_MSG.GENRE,
              channel:Globals.UNSOLICITED_ERROR_MSG.CHANNEL,
              language:Globals.UNSOLICITED_ERROR_MSG.LANGUAGE,
              productionType:Globals.UNSOLICITED_ERROR_MSG.PRODUCTIONTYPE,
              targetAudience:Globals.UNSOLICITED_ERROR_MSG.TARGETAUDIENCE,
              format:Globals.UNSOLICITED_ERROR_MSG.FORMAT,
              currency:Globals.UNSOLICITED_ERROR_MSG.CURRENCY,
              duration:Globals.UNSOLICITED_ERROR_MSG.DURATION
            }
    const { 
        errors, 
        getUnsolicitedProposal, 
        popUpState,
        loading,
        setLoading,
        busyLoad,
        // validateField,
        // validateFields,
        isRegFailed,
        setRegFailure,
        openPopUp,
        setPopUpState,
        setErrors,
        setactiveHeader
    } = Unsolicited(hooksProps);
      useEffect(() => {
        setDuration('')
        setNoOfMiniEpisodes('')
        setEpisodeMiniDuration('')
          setTotalDuration(values?.noOfEpisodes * values?.episodeDuration);
          setNoOfEpisodes(values.noOfEpisodes)
          setEpisodeDuration(values.episodeDuration)
          // console.log(totalDuration)
      }, [values?.noOfEpisodes, values?.episodeDuration]);
      useEffect(() => {
          // alert()
          setDuration('')
          setNoOfEpisodes('')
          setEpisodeDuration('')
          setTotalMiniDuration(values?.noOfMiniEpisodes * values?.episodeMiniDuration);
          setNoOfMiniEpisodes(values.noOfMiniEpisodes)
          setEpisodeMiniDuration(values.episodeMiniDuration)
      }, [values?.noOfMiniEpisodes, values?.episodeMiniDuration]);
    const { row,activeHeader } = location.state || {};
    const [fileItems,setFileItems] =useState([])
    const [isDisabled,setIsDisabled] = useState(false)
    useEffect(()=>{
        setactiveHeader(activeHeader)
        if(row.proposalId){
            setProposalData(row);
            setLoading(true);     
            getUnsolicitedProposal(row.proposalId,false).then((propData)=>{
                if (propData && propData.documents) {
                        setFileItems(propData.documents)
                          } else {
                            setFileItems([]);
                          }
            const videoFile= propData?.documents?.find(doc => doc?.documentFor === "VP") || '';
            const pdfFile= propData?.documents?.find(doc => doc?.documentFor === "PSH") || '';
            videoFile && setVideoFile({name:videoFile?.documentName,type:videoFile?.documentType,path:videoFile?.documentPath,uploadedAt:videoFile?.uploadedAt,documentId:videoFile?.documentId})
            pdfFile &&  setPdfFile({name:pdfFile?.documentName,type:pdfFile?.documentType,path:pdfFile?.documentPath,uploadedAt:pdfFile?.uploadedAt,documentId:pdfFile?.documentId})
                setProposalData(propData);

                setLoading(false);
                setProposalTitle(propData?.title.trim() || "");

                // setChannel(propData?.channelId || "");
                // setScriptedUnscripted(propData?.contentTypeId || "");
                // setGenre(propData?.genreId || "");
                // setCluster(propData?.clusterId || "");
                // setLanguage(propData?.languageId || "");
                // setNoOfEpisodes(propData?.noOfEpisodes || "");
                // setEpisodeDuration(propData?.episodeDuration || "");
                setNewGenre(propData?.otherGenre || "");
                setTotalDuration(propData?.totalEpisodesDuration || "");
                setTotalMiniDuration(propData?.totalEpisodesDuration || "")
                setSynopsis(propData?.synopsis || "");
                setLogline(propData?.logLine || "");
                setTargetBudget(formatCurrency(propData?.targetBudget) || "");
                setProductionSchedule(propData?.productionTimeLine || "");
                setEpisodeStructureOutline(propData?.episodeStructure || "");
                setLocationStudioInfo(propData?.locationStudioInfo || "");
                setCastPresenterInfo(propData?.castPresenterInfo || "");
                setBrandIntegrationOpportunities(propData?.brandIntegration || "");
                setProjectStatus(propData?.projectStatus || "");
                setKeyTeam(propData?.keyTeams || "");
                setArtistName(propData?.artistName || "");
                setSongName(propData?.songName || "");
                setSocialLinks((propData?.referenceLinks && propData?.referenceLinks.split(",")) || [""]);
                setIsDisabled(propData?.status === 3);
                

                    fetchAllCountries().then((response) => {
                        countryIds = nameToIdMap(response.data.content, "countryName","countryId");
                        fieldNames.countries=nameToIdMap(response.data.content,"countryId", "countryName");
                        dispatch(setAllCountries({ allCountries: response.data.content }));
                        let c=fieldNames.countries[propData?.countryId]
                        console.log(c);
                        
                        setCountry(fieldNames.countries[propData?.countryId]);
                        onCountryChange(fieldNames.countries[propData?.countryId],propData);
                    }).catch((error) => {
                        console.error(Globals.ERROR_MESSAGES.GENERIC_API_ERROR, error);
                    });


                    fetchAllProduction().then((response) => {
                        productionTypeIds = nameToIdMap(response.data.content,"productionTypeName","productionTypeId");
                        fieldNames.productionTypes=nameToIdMap(response.data.content,"productionTypeId", "productionTypeName");
                        setAllProductionTypes(response.data.content.map(productionType => productionType.productionTypeName));
                        setProductionType(fieldNames.productionTypes[propData?.productionTypeId] || "");
                        setproductionTypeFull(response.data.content)
                        handleCountryChange("productionType",fieldNames?.productionTypes[propData?.productionTypeId]) 
                        const selectedObjects = response.data.content.find(item =>
                            fieldNames?.productionTypes[propData?.productionTypeId]?.includes(item?.productionTypeName)
              );  
                        setIsMusicVideo(selectedObjects?.isMusicVideo)
                        setIsBrandIntegrationOpportunities(selectedObjects?.isBrandIntegrationOpportunities)
                    })

                    
                    fetchByfilter("TargetAudiences").then((response) => {
                        targetAudienceIds = nameToIdMap(response.data.content["TargetAudiences"]);
                        fieldNames.targetAudiences=nameToIdMap(response.data.content["TargetAudiences"],"id", "name");
                        setAllTargetAudiences(response.data.content["TargetAudiences"].map(targetAudience => targetAudience.name));
                        setTargetAudience(fieldNames.targetAudiences[propData?.targetAudienceId] || "");
                    })
                
                    fetchAllFormats().then((response) => {
                        formatIds = nameToIdMap(response.data.content, "formatName","formatId");
                        fieldNames.formats=nameToIdMap(response.data.content,"formatId", "formatName");
                        let formatTypes=nameToIdMap(response.data.content, "formatName","type");
                        setFormatTypes(formatTypes);
                        setAllFormats(response.data.content.map(format => format.formatName));
                        setFormat(fieldNames.formats[propData?.formatId] || "");
                        if(formatTypes[fieldNames.formats[propData?.formatId]]  === "M" || formatTypes[fieldNames.formats[propData?.formatId]] === "E" ){
                            setIsEpisodeStructure(true)
                          }else{
                            setIsEpisodeStructure(false)
                          }
                        setTimeout(()=>{
                            if(formatTypes[fieldNames.formats[propData?.formatId]]){
                                setNoOfEpisodes(propData?.noOfEpisodes || "");
                                setNoOfMiniEpisodes(propData?.noOfEpisodes || "");
                                setEpisodeMiniDuration(propData?.episodeDuration || "")
                                setEpisodeDuration(propData?.episodeDuration || "");
                            }else{
                                setDuration(propData?.episodeDuration || "");
                            }
                        },500)              
                        setValues({
                            duration: propData?.episodeDuration,
                            noOfEpisodes: propData?.noOfEpisodes,
                            episodeDuration: propData?.episodeDuration,
                            totalDuration:totalDuration,
                            noOfMiniEpisodes: propData?.noOfEpisodes,
                            episodeMiniDuration: propData?.episodeDuration,
                            totalMiniDuration: totalMiniDuration
                                  })
                    })


                    fetchByfilter("Currencies").then((response) => {
                        currencyIds = nameToIdMap(response.data.content["Currencies"]);
                        fieldNames.currencies=nameToIdMap(response.data.content["Currencies"],"id", "name");
                        setAllCurrencies(response.data.content["Currencies"].map(currency => currency.name));
                        setCurrency(fieldNames.currencies[propData?.currencyId] || "");
                    })
            })
        }
    },[row])



    const getGenresByCluster=(clusterId,propData=null)=>{
        setGenre('');
        if (clusterId) {
            fetchGenresByCluster(clusterId).then((response) => {
                genreIds = nameToIdMap(response.data.content,"genreName","genreId");
                fieldNames.genres=nameToIdMap(response.data.content,"genreId","genreName");
                dispatch(setAllGeners({ allGeners: [...response.data.content] }));
                setGenre(fieldNames.genres[propData?.genreId] || "");
                onGenreChange(fieldNames.genres[propData?.genreId] || "")
            })
        }
    }
    const validateField1 = (fieldName, value) => {
        if (!value || value.trim() === '') {
            setErrors({ ...errors, [fieldName]: error[fieldName] });
            isButtonEnabled()
            return false;
        } else {
            const newErrors = { ...errors };
            setErrors({ ...errors, [fieldName]: '' });
            delete newErrors[fieldName];
            setErrors(newErrors);
            isButtonEnabled()
            return true;
        }
        
    };
    const handleProposalTitleChange = (e) => {
        const value = e.target.value;
        setProposalTitle(value);
        validateField1('proposalTitle', value);
    };
    const handleSynopsisChange = (key,e) => {
        const value = e;
        setSynopsis(value);
        validateField1('synopsis', value);
    };
    const logLineChange = (key,e) => {
        const value = e;
        setLogline(value);
        validateField1('logline', value);
    };
    const episodeChange = (key,e) => {
        const value = e;
        setEpisodeStructureOutline(value);
        validateField1('episodeStructureOutline', value);
        isEpisodeStructure && validateField1('episodeStructureOutline', value);
    };
    const locationChange = (key,e) => {
        const value = e;
        setLocationStudioInfo(value);
        validateField1('locationStudioInfo', value);
    };
    
    const castChange = (key,e) => {
        const value = e;
        setCastPresenterInfo(value);
        validateField1('castPresenterInfo', value);
    };
    const brandChange = (key,e) => {
        const value = e;
        validateField1('brandIntegrationOpportunities', value);
        setBrandIntegrationOpportunities(value);        
    };
    const keyTeamChange = (key,e) => {
        const value = e;
        setKeyTeam(value);
        validateField1('keyTeam', value);
    };
    const handleOtherChange = (e) => {
        const value = e.target.value;
        setNewGenre(value);
        validateField1('newGenre', value);
    };
    const handleTargetChange = (e) => {
            
            const value = e.target.value;
            const numericValue = value.replace(/,/g, "");
            // const regex = /^[0-9,]*(\.\d{0,2})?$/;
            const regex = /^\d+(\.\d{0,2})?$/;
            
                if (regex.test(numericValue) && numericValue.length <= 15 && (numericValue !== "0" || numericValue === "")) {
                    const formattedCurrency=formatCurrency(numericValue)
                    setTargetBudget(formattedCurrency);
                    validateField1('targetBudget', formattedCurrency);
                } else {
                    // If the value doesn't match the regex, truncate it to two decimal places
                    if (numericValue !== "0" && numericValue !== "") {
                        const truncatedValue = parseFloat(numericValue).toFixed(2);
                        if (truncatedValue.length <= 15) {
                            const formattedCurrency=formatCurrency(truncatedValue)
                            setTargetBudget(formattedCurrency);
                            validateField1('targetBudget', formattedCurrency);
                        } else {
                            // Handle case where truncated value exceeds max length
                            const maxLengthValue = truncatedValue.slice(0, 15);
                            const formattedCurrency=formatCurrency(maxLengthValue)
                            numericValue !== "0" && setTargetBudget(formattedCurrency);
                            validateField1('targetBudget', formattedCurrency);
                        }
                    } else {
                        // Allow deletion of characters
                        if(numericValue!=="0"){
                            const formattedCurrency=formatCurrency(numericValue);
                            setTargetBudget(formattedCurrency);
                            validateField1('targetBudget', formattedCurrency);
                        }
                        
                    }
            }
        };
    // const handleTargetChange = (e) => {
    //     const value = e.target.value;
    //     const regex = /^\d+(\.\d{0,2})?$/;
    
    //     if (regex.test(value) && value.length <= 15 && (value !== "0" || value === "")) {
    //         setTargetBudget(value);
    //         validateField1('targetBudget', value);
    //     } else {
    //         // If the value doesn't match the regex, truncate it to two decimal places
    //         if (value !== "0" && value !== "") {
    //             const truncatedValue = parseFloat(value).toFixed(2);
    //             if (truncatedValue.length <= 15) {
    //                 setTargetBudget(truncatedValue);
    //                 validateField1('targetBudget', truncatedValue);
    //             } else {
    //                 // Handle case where truncated value exceeds max length
    //                 const maxLengthValue = truncatedValue.slice(0, 15);
    //                 value !== "0" && setTargetBudget(maxLengthValue);
    //                 validateField1('targetBudget', maxLengthValue);
    //             }
    //         } else {
    //             // Allow deletion of characters
    //             if(value!=="0"){
    //                 setTargetBudget(value);
    //                 validateField1('targetBudget', value);
    //             }
                
    //         }
    //     }
    // };
    
    const handleCountryChange = (key,value) => {
            validateField1(key,value);
    };


    const onCountryChange = (selectedCountry,propdata=null) => {
        setCountry(selectedCountry);
        setChannel('');
        setScriptedUnscripted('');
        setCluster('');
        setGenre('');
        setLanguage('');
        if (countryIds[selectedCountry]) {
            fetchChannelsByCountry(countryIds[selectedCountry]).then((response) => {
                channelIds = nameToIdMap(response.data.content,"channelName","channelId");
                fieldNames.channels=nameToIdMap(response.data.content,"channelId","channelName");
                dispatch(setAllChannels({ allChannels: response.data.content }));
                setChannel(fieldNames.channels[propdata?.channelId] || "")
                onChannelChange(fieldNames.channels[propdata?.channelId] || "",propdata)
            })
        }

        if (countryIds[selectedCountry]) {
            fetchScriptTypesByCountry(countryIds[selectedCountry]).then((response) => {
                scriptTypesIds = nameToIdMap(response.data.content, "scriptTypeName","scriptTypeId");
                dispatch(setUSPScriptTypes({uspScriptTypes:response.data.content.map(script => script.scriptTypeName)}))
                fieldNames.scriptTypes=nameToIdMap(response.data.content,"scriptTypeId","scriptTypeName");
                setAllScriptTypes(response.data.content.map(script => script.scriptTypeName));
                setScriptedUnscripted(fieldNames.scriptTypes[propdata?.contentTypeId] || "")
                onScriptChange(fieldNames.scriptTypes[propdata?.contentTypeId] || "",propdata)
            })
        }
        // setErrors({});
        handleCountryChange("country",country)
        setErrors((prevErrors) => ({
            ...prevErrors,
            country:'',
            // scriptedUnscripted:'',
            // genre:'',
            // channel:'',
            // language:'',
            // productionType:'',
            // targetAudience:''
          }));

    }

    const onChannelChange = (selectedChannel,propData=null) => {
            const channelIdFomRedux= allChannelsDetails.find((channel) => channel?.name === selectedChannel)?.id;
            const localChannelId= channelIds[selectedChannel]?channelIds[selectedChannel]:channelIdFomRedux
            setChannel(selectedChannel);
            setLanguage('')
            if (localChannelId) {
                fetchLanguagesByChannel(localChannelId).then((response) => {
                    languageIds = nameToIdMap(response.data.content,"languageName","languageId");
                fieldNames.languages=nameToIdMap(response.data.content,"languageId","languageName");
                    dispatch(setAllLanguages({ allLanguages: response.data.content }));
                setLanguage(fieldNames.languages[propData?.languageId] || '');
                })
            }
           if(selectedChannel) handleCountryChange("channel",selectedChannel)
            // setErrors({});
        }
    const onScriptChange = (selectedScript,propdata=null) => {
            setScriptedUnscripted(selectedScript);
            setGenre('');        
        if ( (countryIds[country] || propdata?.countryId) && scriptTypesIds[selectedScript]) {
            fetchClustersByCountryAndScript(countryIds[country] || propdata?.countryId,scriptTypesIds[selectedScript]).then((response) => {
                    clusterIds = nameToIdMap(response.data.content,"clusterName","clusterId");
                    setAllClusters(response.data.content.map(cluster => cluster.clusterName));
                    setCluster(response.data.content[0].clusterName);
                    getChannelesByClusterId(response?.data?.content?.[0]?.clusterId);
                getGenresByCluster(response.data.content[0].clusterId,propdata);
                })
               if(selectedScript) validateField("scriptedUnscripted")
            }
            // setErrors({});
        }
    const getChannelesByClusterId = (clusterId) => {
        fetchChannelbyClusters("Channel", clusterId).then((response) => {
            dispatch(setAllChannelsByClusterId({ allChannelsByClusterId: response?.data?.content }));
        })
    }

        const onGenreChange = (selectedGenre) => {
            setGenre(selectedGenre);
            if(selectedGenre=="Other"){
                setNewGenreFlag(true);// true
            }else{
                setNewGenreFlag(false);
            }
           if(selectedGenre) handleCountryChange("genre",selectedGenre)
            // setErrors({});
        }
    
    
        const handleKeyDown = (event) => {
            if (
                ["Backspace", "Delete", "Tab", "Escape", "Enter", "ArrowLeft", "ArrowRight"].indexOf(event.key) !== -1
              ) {
                return;
              }
              // Prevent non-numeric input
              if ((event.key < '0' || event.key > '9') && (event.key !== '.')) {
                event.preventDefault();
              }
        }
        const handleDropdownChangeLanguage = (setter,isFormat=false) => (selectedValues) => {
            setter(selectedValues);
            handleCountryChange("language",selectedValues) 
        }
        const handleDropdownChangeProduction = (setter,isFormat=false) => (selectedValues) => {
            setter(selectedValues);
            handleCountryChange("productionType",selectedValues) 
            const selectedObjects = productionTypeFull.find(item =>
                selectedValues.includes(item.productionTypeName)
              );  
              setIsMusicVideo(selectedObjects?.isMusicVideo)
              setIsBrandIntegrationOpportunities(selectedObjects?.isBrandIntegrationOpportunities)
            isButtonEnabled()
        }
        const handleDropdownChangeTarget = (setter,isFormat=false) => (selectedValues) => {
            setter(selectedValues);
            handleCountryChange("targetAudience",selectedValues) 
        }
        const handleDropdownChangeFormat = (setter) => (selectedValues) => {
            handleCountryChange("format",selectedValues)
            setter(selectedValues);
            setDuration('');
            setNoOfEpisodes('');
            setEpisodeDuration('');
            setTotalDuration('')
            setTotalDuration('')
            setNoOfMiniEpisodes('')
            setEpisodeMiniDuration('')
            setTotalMiniDuration('')
            setValues({
                duration: '',
                noOfEpisodes: '',
                episodeDuration: '',
                totalDuration: totalMiniDuration,
                noOfMiniEpisodes: '',
                episodeMiniDuration: '',
                totalMiniDuration: totalMiniDuration
            })
            setErrors((prevErrors) => ({
                ...prevErrors,
                duration:'',
                noOfEpisodes:'',
                episodeDuration:'',
                noOfMiniEpisodes:'',
                episodeMiniDuration:'' 
              }));
              if(formatTypes[selectedValues]  === "M" || formatTypes[selectedValues]  === "E" ){
                setIsEpisodeStructure(true)
              }else{
                setIsEpisodeStructure(false)
              }
              isButtonEnabled()
        // setErrors({});

    };
    const handleDropdownChangeCurrency = (setter,isFormat=false) => (selectedValues) => {
        setter(selectedValues);
        handleCountryChange("currency",selectedValues) 
    }
    


    const handleSocialMedia = (index, event) => {
        const newSocialLinks = [...socialLinks];
        newSocialLinks[index] = event.target.value;
        setSocialLinks(newSocialLinks);
    };

    const addSocialLink = () => {
        setSocialLinks([...socialLinks, '']);
    };

    const removeSocialLink = (index) => {
        const newSocialLinks = socialLinks.filter((_, i) => i !== index);
        setSocialLinks(newSocialLinks);
    };


    
useEffect(()=>{ 
 setNoOfEpisodes('')
 setEpisodeDuration('')
 setNoOfMiniEpisodes('')
 setEpisodeMiniDuration('')
setDuration(values.duration)
},[values.duration])

    const handleInputChange = (e,limit=100) => {
        const { id, value } = e?.target || '';
        if(id!==undefined && value!==undefined && value?.length <= limit &&value > 0 || value === ""){
            setValues({
                ...values,
                [id]: value
            });
            validateField(id, value);
        }
        
    };

    const validateField = (field, value) => {
        let error = '';
        isButtonEnabled()
        switch (field) {
            case 'duration':
                error = validateDuration(value);
                break;
            case 'noOfEpisodes':
                error = validateNoOfEpisodes(value);
                break;
            case 'episodeDuration':
                error = validateEpisodeDuration(value);
                break;
            case 'totalDuration':
                error = validateTotalDuration(value);
                break;
            case 'noOfMiniEpisodes':
                error = validateNoOfMiniEpisodes(value);
                break;
            case 'episodeMiniDuration':
                error = validateEpisodeMiniDuration(value);
                break;
            case 'totalMiniDuration':
                error = validateTotalMiniDuration(value);
                break;
            default:
                break;
        }
        setErrors({
            ...errors,
            [field]: error
        });
    };

    const validateDuration = (duration) => {
        if (!duration || parseFloat(duration) <= 0) {
            return 'Please enter a valid duration';
        }
        return '';
    };

    const validateNoOfEpisodes = (noOfEpisodes) => {
        if (!noOfEpisodes || parseFloat(noOfEpisodes) <= 7) {
            return 'Please enter a number above 7';
        }
        return '';
    };

    const validateEpisodeDuration = (episodeDuration) => {
        if (!episodeDuration || parseFloat(episodeDuration) <= 0) {
            return 'Please enter a valid episode duration';
        }
        return '';
    };

    const validateTotalDuration = (totalDuration) => {
        if (!totalDuration) {
            return 'Please enter total duration';
        }
        return '';
    };

    const validateNoOfMiniEpisodes = (noOfMiniEpisodes) => {
        if (!noOfMiniEpisodes || parseFloat(noOfMiniEpisodes) <= 0 || parseFloat(noOfMiniEpisodes) > 7) {
            return 'Please enter a number from 1 to 7';
        }
        return '';
    };

    const validateEpisodeMiniDuration = (episodeMiniDuration) => {
        if (!episodeMiniDuration || parseFloat(episodeMiniDuration) <= 0) {
            return 'Please enter a valid episode duration';
        }
        return '';
    };

    const validateTotalMiniDuration = (totalMiniDuration) => {
        if (!totalMiniDuration) {
            return 'Please enter total duration';
        }
        return '';
    };

    const validateField2 = (fieldName, value, errors = {}) => {
        if (!value || value?.trim?.() === '') {
            errors[fieldName] = error[fieldName];
        } else {
            delete errors[fieldName];
        }
        return errors;
    };

    const [isFileValid, setIsFileValid] = useState('');
    const checkForValidFile = (e) => {
        setIsFileValid(e);
    }

    const isButtonEnabled = () => {
        return (
            proposalTitle&&
            synopsis&&
            logline&&
            country&&
            scriptedUnscripted&&
            (genre==='Other'?(newGenreFlag && newGenre) : genre)
            &&
            channel&&
            language&&
            targetAudience&&
            format&&
            keyTeam &&
            currency&&
            targetBudget&& 
            pdfFile?.name &&
            pdfFile?.path &&
            ( (duration)|| 
            (noOfEpisodes>7 &&
            episodeDuration &&
            totalDuration ) ||
            (noOfMiniEpisodes<=7 &&
            episodeMiniDuration &&
            totalMiniDuration))&& 
             (isMusicVideo ? videoFile?.name : true) &&
             (isBrandIntegrationOpportunities? brandIntegrationOpportunities: true)&&
             (isEpisodeStructure? episodeStructureOutline:true)
        )
    };
       const handleInputChange1 = (e,setter) => {
        setter(e.target.value);
    }
    const handleFileRemove1 = () => {
        setPdfFile(null);
      };
    
    
      const handleFileRemove2 = () => {
        setVideoFile(null);
      };
       const validateAllFields = () => {
           const newErrors = { ...errors };
           validateField2('proposalTitle', proposalTitle || '', newErrors);
           validateField2('productionType', productionType, newErrors);
           validateField2('channel', channel, newErrors);
           validateField2('cluster', cluster, newErrors);
           validateField2('country', country, newErrors);
           validateField2('scriptedUnscripted', scriptedUnscripted, newErrors);
           validateField2('genre', genre, newErrors);
           validateField2('currency', currency, newErrors);
           validateField2('language', language, newErrors);
           validateField2('targetAudience', targetAudience, newErrors);
           validateField2('format', format, newErrors);
       
           if (genre === Globals.OTHER) validateField2('newGenre', newGenre, newErrors);
           if (formatTypes[format] === "E") {
               validateField2('noOfEpisodes', noOfEpisodes, newErrors);
               validateField2('episodeDuration', episodeDuration, newErrors);
               validateField2('totalDuration', totalDuration, newErrors);
           } else if (formatTypes[format] === "M") {
               validateField2('noOfMiniEpisodes', noOfMiniEpisodes, newErrors);
               validateField2('episodeMiniDuration', episodeMiniDuration, newErrors);
               validateField2('totalMiniDuration', totalMiniDuration, newErrors);
           } else if (formatTypes[format] === "D") {
               validateField2('duration', duration, newErrors);
           }
       
           validateField2('synopsis', synopsis, newErrors);
           validateField2('logline', logline, newErrors);
           validateField2('targetBudget', targetBudget, newErrors);
           validateField2('productionSchedule', productionSchedule, newErrors);
           validateField2('episodeStructureOutline', episodeStructureOutline, newErrors);
           validateField2('locationStudioInfo', locationStudioInfo, newErrors);
           validateField2('castPresenterInfo', castPresenterInfo, newErrors);
           validateField2('brandIntegrationOpportunities', brandIntegrationOpportunities, newErrors);
           validateField2('keyTeam', keyTeam, newErrors);
           setErrors(newErrors);
           return Object.keys(newErrors).every(key => !newErrors[key]);
       };
        
       const handleSubmit = (isSave=true) => {
        // validateAllFields();

        if (isSave) {
            // Proceed with form submission
            isButtonEnabled() && openPopUp("Save",true)
        } else {
            // Show errors
            isFormValuesValid && openPopUp("Submit",true)
        }
    };
   
    const handleVideoFile=(file)=>{
        setVideoFile(file)
        }
        const handlePdfFile=(file)=>{
            setPdfFile(file)
        }
        function displayFileNames(documentFor) {
            const filteredFiles = fileItems.filter((item) => item.documentFor === documentFor);
            return filteredFiles
          }

    const isSaveButtonEnabled = () => {
        return !!(
            proposalTitle.length > 0 ||
            synopsis.length > 0 ||
            logline.length > 0 ||
            country ||
            scriptedUnscripted ||
            newGenreFlag || newGenre ||
            channel ||
            language ||
            targetAudience ||
            format ||
            keyTeam ||
            currency ||
            targetBudget ||
            pdfFile?.name ||
            pdfFile?.path||
            ((duration) ||
                (noOfEpisodes ||
                    episodeDuration ||
                    totalDuration) ||
                (noOfMiniEpisodes ||
                    episodeMiniDuration ||
                    totalMiniDuration)) ||
            projectStatus ||
            songName ||
            artistName ||
            socialLinks[0] ||
            socialLinks[1] ||
            socialLinks[2] ||
            (isMusicVideo || (videoFile?.name || videoFile?.path)) ||
            (isBrandIntegrationOpportunities || brandIntegrationOpportunities) ||
            (isEpisodeStructure || episodeStructureOutline)
        )
    };
    const handleSaveDraft = () => {
        isSaveButtonEnabled() && openPopUp("Save");
    }
    const isValidNoOfEpisodes = noOfEpisodes !== ""
  ? format === Globals.UNSOLICITED_PROPOSAL.MINI_SERIES
    ? Number(noOfEpisodes) <= 7
    : format === Globals.UNSOLICITED_PROPOSAL.BIG_SERIES_MORE
      ? Number(noOfEpisodes) > 7
      : true
  : true;

    const isFormValuesValid = (
        (
            proposalTitle &&
            synopsis &&
            logline &&
            country &&
            scriptedUnscripted &&
            (genre === 'Other' ? (newGenreFlag && newGenre) : genre) &&
            channel &&
            language &&
            targetAudience &&
            format &&
            keyTeam &&
            currency &&
            targetBudget &&
            pdfFile?.name &&
            ((duration) ||
                (format === Globals.UNSOLICITED_PROPOSAL.BIG_SERIES_MORE && (parseInt(noOfEpisodes) > 7 &&
                    episodeDuration &&
                    totalDuration)) ||
                (format === Globals.UNSOLICITED_PROPOSAL.MINI_SERIES && (parseInt(noOfMiniEpisodes) <= 7 &&
                    episodeMiniDuration &&
                    totalMiniDuration))
            ) &&
            (isMusicVideo ? videoFile?.name : true) &&
            (isBrandIntegrationOpportunities ? brandIntegrationOpportunities : true) &&
            (isEpisodeStructure ? episodeStructureOutline : true) &&
            (errors.proposalTitle === '' || errors.proposalTitle === undefined) &&
            (errors.synopsis === '' || errors.synopsis === undefined) &&
            (errors.logline === '' || errors.logline === undefined) &&
            (errors.episodeStructureOutline === '' || errors.episodeStructureOutline === undefined) &&
            (errors.locationStudioInfo === '' || errors.locationStudioInfo === undefined) &&
            (errors.castPresenterInfo === '' || errors.castPresenterInfo === undefined) &&
            (errors.brandIntegrationOpportunities === '' || errors.brandIntegrationOpportunities === undefined) &&
            (errors.keyTeam === '' || errors.keyTeam === undefined) &&
            (errors.newGenre === '' || errors.newGenre === undefined) &&
            (errors.targetBudget === '' || errors.targetBudget === undefined) &&
            (errors.country === '' || errors.country === undefined) &&
            (errors.scriptedUnscripted === '' || errors.scriptedUnscripted === undefined) &&
            (errors.genre === '' || errors.genre === undefined) &&
            (errors.channel === '' || errors.channel === undefined) &&
            (errors.language === '' || errors.language === undefined) &&
            (errors.productionType === '' || errors.productionType === undefined) && //true
            (errors.targetAudience === '' || errors.targetAudience === undefined) && //true
            (errors.format === '' || errors.format === undefined) && //true
            (errors.currency === '' || errors.currency === undefined) && //true
            (format === Globals.UNSOLICITED_PROPOSAL.MINI_SERIES ? Number(values.noOfMiniEpisodes) >= 1 : true) && //true
           (format === Globals.UNSOLICITED_PROPOSAL.MINI_SERIES ? noOfMiniEpisodes !== "" ? (Number(noOfMiniEpisodes) >= 1 && Number(noOfMiniEpisodes) <= 7) : true : true) && //true
           (format === Globals.UNSOLICITED_PROPOSAL.BIG_SERIES_MORE ? Number(values.noOfEpisodes) >= 1 : true)  &&
           
           //(Number(values.noOfEpisodes) >= 1) && //true
            isValidNoOfEpisodes &&
            ((Number(values.episodeMiniDuration) !== 0) || (Number(episodeDuration) !== 0) || Number(duration))
        )
    ) ? true : false;
    return (
        <div id="create-unsolicited-container" className="register-container">
            <GenericHeader title={Globals.UNSOLICITED_PROPOSAL.CREATE_UNSOLICITED_PROPOSAL_TITLE} onClose={()=>openPopUp("Abort")} />
            {loading ?<Loader height={50} width={50} component="CreateUnsolicited"/>:
            <div id="create-unsolicited-form" className="bottom-margin-zero">
                <div id="create-unsolicited-form-content" className="register-form register-form-content bottom-zero bottom-margin-zero">
                    <h3 id="proposal-details-title" className="basic-info">{Globals.UNSOLICITED_PROPOSAL.PROPOSAL_DETAILS}</h3>
                    <label className="label-note"><span><img className="infoTooltip" src={blueInfoIcon} /></span>{Globals.UNSOLICITED_PROPOSAL.NOTE}</label>
                    <div id="proposal-details-row-1" className="row-1-content">
                        <div id="proposal-title-holder">
                            <label id="proposal-title-label" className="language">{Globals.UNSOLICITED_PROPOSAL.PROPOSAL_TITLE}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <input type="text" id="proposal-title-input" maxLength = {100} className="name-inp titledDropdownSize1" value={proposalTitle} onChange={handleProposalTitleChange} onBlur={handleProposalTitleChange} required tabIndex="1"></input>
                            {errors.proposalTitle && <div><p className="invalidCredential1" > <img  src={Globals.IMG.ERROR}  className='errorimg' alt="password error"/><span>{errors.proposalTitle}</span></p></div>}
                        </div>
                    </div>
                    <div id="proposal-details-row-2" className="row-1-content">
                        <div id="region-holder">
                            <label id="region-label" className="country">{Globals.UNSOLICITED_PROPOSAL.COUNTRY}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <span className="comp-titles-list" onBlur={()=>handleCountryChange("country",country)}>
                            <DropdownList tabIndex={2} options={allCountriesData} selectClass={`titledDropdownSize1 ${isDisabled ? "dropdown-disabled" : ""}`} selectedItem={country} placeHolderValue={''} onSelect={onCountryChange} 
                            disabled={isDisabled}
                            />
                            </span>
                            {errors.country && <div className='invalidCredential1'><img className='errorimg1' src={Globals.IMG.ERROR}  alt="password error" /><span className="error">{errors.country}</span></div>}
                        </div>
                        <div id="scripted-unscripted-holder">
                            <label id="scripted-unscripted-label" className="language">{Globals.UNSOLICITED_PROPOSAL.SCRIPTED_UNSCRIPTED}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <span className="comp-titles-list" onBlur={()=>handleCountryChange("scriptedUnscripted",scriptedUnscripted)}>
                            <DropdownList
                                selectClass={`titledDropdownSize1 ${isDisabled ? "dropdown-disabled" : ""}`}
                                placeHolderValue={''}
                                options={scriptData}
                                onSelect={onScriptChange}
                                selectedItem={scriptedUnscripted}
                                onBlur={() => validateField("scriptedUnscripted")}
                                required
                                tabIndex="3"
                                disabled={isDisabled}
                            />
                            </span>
                           
                            {errors.scriptedUnscripted && <div className='invalidCredential1'><img className='errorimg1' src={Globals.IMG.ERROR} alt="password error" /><span className="error">{errors.scriptedUnscripted}</span></div>}
                        </div>
                        <div id="cluster-holder">

                            <label id="cluster-label" className="country">{Globals.UNSOLICITED_PROPOSAL.CLUSTER}</label>
                            <span className="comp-titles-list" onBlur={()=>handleCountryChange("cluster",cluster)}>
                            <DropdownList selectClass={"titledDropdownSize1 dropdown-disabled"} options={Clusters} placeHolderValue={''}  selectedItem={cluster} tabIndex="4" disabled 
                            
                            />
                            </span>
                            
                            {/* {errors.cluster && <span className="error">{errors.cluster}</span>} */}
                        </div>
                    </div>
                    <div className='unsoli-brief-grid-container row-1-content'>
                    {/* <div id="proposal-details-row-3" className="row-1-content"> */}
                        <div id="genre-holder">
                            <label id="genre-label" className="channels">{Globals.UNSOLICITED_PROPOSAL.GENRE}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <span className="comp-titles-list" onBlur={()=>handleCountryChange("genre",genre)}>
                            <DropdownList
                                selectClass={"titledDropdownSize1"}
                                placeHolderValue={''}
                                options={scriptedUnscripted && allGenersData}
                                selectedItem={genre}
                                onSelect={onGenreChange}
                                 onBlur={() => validateField("genre")}
                                required
                                tabIndex="5"
                            />
                            </span>
                            
                            {errors.genre && <div className='invalidCredential1'><img className='errorimg1' src={Globals.IMG.ERROR} alt="password error" /><span className="error">{errors.genre}</span></div>}
                        </div>
                        {newGenreFlag && <div id="new-genre-holder">
                            <label id="new-genre-label" className="channels">{Globals.NEW_GENRE}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <input type="text" id="proposal-title-input" className="name-inp titledDropdownSize1" value={newGenre} onChange={handleOtherChange} onBlur={handleOtherChange} required tabIndex="6" maxLength={30}></input>
                            {errors.newGenre && <div className='invalidCredential1' style={{marginBottom:"25px",marginTop:"5px"}}><img className='errorimg1' src={Globals.IMG.ERROR} alt="password error" /><span className="error">{errors.newGenre}</span></div>}
                        </div>}
                        <div id="channel-holder">
                            <label id="channel-label" className="channels">{Globals.UNSOLICITED_PROPOSAL.CHANNEL}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <span className="comp-titles-list" onBlur={()=>handleCountryChange("channel",channel)}>
                            <DropdownList
                                selectClass={"titledDropdownSize1"}
                                placeHolderValue={''}
                                options={scriptedUnscripted && allChannelsData}
                                onSelect={onChannelChange}
                                selectedItem={channel}
                                onBlur={() => validateField("channel")}
                                required
                                tabIndex="7"
                            />
                            </span>
                             {errors.channel && <div className='invalidCredential1' style={{marginBottom:"25px"}}  ><img src={Globals.IMG.ERROR} alt="password error" /><span className="error">{errors.channel}</span></div>}
                        
                    </div>
                    {/* <div id="proposal-details-row-4" className="row-1-content"> */}
                        <div id="language-holder">
                            <label id="language-label" className="language">{Globals.SIGNUP.LANGUAGE}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <span className="comp-titles-list" onBlur={()=>handleCountryChange("language",language)}>
                            <DropdownList   
                                selectClass={"titledDropdownSize1"}
                                placeHolderValue={''}
                                options={channel && allLanguagesData}
                                onSelect={handleDropdownChangeLanguage(setLanguage)}
                                selectedItem={language}
                                onBlur={() => validateField("language")}
                                required
                                tabIndex="8"
                            />
                            </span>
                            {errors.language && <div className='invalidCredential1'><img className='errorimg1' src={Globals.IMG.ERROR} alt="password error" /><span className="error">{errors.language}</span></div>}
                            </div>
                        <div id="production-type-holder">
                            <label id="production-type-label" className="language">{Globals.UNSOLICITED_PROPOSAL.PRODUCTION_TYPE}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <span className="comp-titles-list" onBlur={()=>handleCountryChange("productionType",productionType)}>
                            <DropdownList
                                selectClass={"titledDropdownSize1"}
                                placeHolderValue={''}
                                options={ProductionTypes}
                                selectedItem={productionType}
                                onSelect={handleDropdownChangeProduction(setProductionType)}
                                onBlur={() => {
                                    setTouched(prev => ({ ...prev, productionType: true }));
                                    validateField("productionType");
                                }}
                                required
                                tabIndex="9"
                            />
                            {touched.productionType && errors.productionType && <div className='invalidCredential1'><img className='errorimg1' src={Globals.IMG.ERROR} alt="password error" /><span className="error">{errors.productionType}</span></div>}
                            </span>
                        </div>
                        <div id="target-audience-holder">
                            <label id="target-audience-label" className="language">{Globals.UNSOLICITED_PROPOSAL.TARGET_AUDIENCE}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <span className="comp-titles-list" onBlur={()=>handleCountryChange("targetAudience",targetAudience)}>
                            <DropdownList
                                selectClass={"titledDropdownSize1"}
                                placeHolderValue={''}
                                options={TargetAudiences}
                                onSelect={handleDropdownChangeTarget(setTargetAudience)}
                                selectedItem={targetAudience}
                                onBlur={() => validateField("targetAudience")}
                                required
                                tabIndex="10"
                            />
                            </span>
                            {errors.targetAudience && <div className='invalidCredential1'><img className='errorimg1' src={Globals.IMG.ERROR} alt="password error" /><span className="error">{errors.targetAudience}</span></div>}
                        </div>
                    </div>
                    <div id="proposal-details-row-5" className="row-1-content">
                        <div id="format-holder">
                            <label id="format-label" className="language">{Globals.UNSOLICITED_PROPOSAL.FORMAT}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <span className="comp-titles-list" onBlur={()=>handleCountryChange("format",format)}>
                            <DropdownList
                                selectClass={"titledDropdownSize1"}
                                placeHolderValue={''}
                                options={Formats}
                                onSelect={handleDropdownChangeFormat(setFormat)}
                                selectedItem={format}
                                onBlur={() => validateField("format")}
                                required
                                tabIndex="12"
                            />
                            </span>
                            {errors.format && <div className='invalidCredential1'><img className='errorimg1' src={Globals.IMG.ERROR} alt="password error" /><span className="error">{errors.format}</span></div>}
                        </div>
                        {formatTypes[format]  === "D" && (
                <div id="duration-holder">
                    <label id="duration-label" className="language">
                    {Globals.UNSOLICITED_PROPOSAL.DURATION}<span id="mandatory" className="mandatory">*</span>
                    </label>
                    <div>
                        <input
                            type="number"
                            id="duration"
                            className="name-inp titledDropdownSize1"
                            value={values.duration}
                            onChange={(e)=>handleInputChange(e,3)}
                            onBlur={(e)=>handleInputChange(e,3)}
                            required
                            tabIndex="13"
                            onKeyDown={handleKeyDown}
                            maxLength={3}
                        />
                    </div>
                    {errors.duration && (
                        <div className='invalidCredential1'>
                           <img src={Globals.IMG.ERROR} alt="password error" className='errorimg1'/>
                            <span className="error">{errors.duration}</span>
                        </div>
                    )}
                </div>
            )}
            {formatTypes[format] === "E" && (
                <>
                    <div id="no-of-episodes-holder">
                        <label id="no-of-episodes-label" className="language">
                        {Globals.UNSOLICITED_PROPOSAL.NO_OF_EPISODES}<span id="mandatory" className="mandatory">*</span>
                        </label>
                        <input
                            type="number"
                            id="noOfEpisodes"
                            className="name-inp width-DropdownSize"
                            value={values.noOfEpisodes}
                            onChange={(e)=>handleInputChange(e,5)}
                            onBlur={(e)=>handleInputChange(e,5)}
                            required
                            tabIndex="14"
                            onKeyDown={handleKeyDown}
                            maxLength={5}
                            min={7}
                        />
                        {((noOfEpisodes!=="" && noOfEpisodes<=7) || values.noOfEpisodes===0||errors.noOfEpisodes) && (
                            <div className='invalidCredential1'>
                                <img className='errorimg1 margin-15px' src={Globals.IMG.ERROR} alt="password error" />
                                <span className="error">{errors.noOfEpisodes || Globals.UNSOLICITED_ERROR_MSG.EPISODE_LESS_THAN_7}</span>
                            </div>
                        )}
                    </div>
                    <div id="episode-duration-holder">
                        <label id="episode-duration-label" className="language">
                        {Globals.UNSOLICITED_PROPOSAL.EPISODE_DURATION}<span id="mandatory" className="mandatory">*</span>
                        </label>
                        <input
                            type="number"
                            id="episodeDuration"
                            className="name-inp width-DropdownSize"
                            value={values.episodeDuration}
                            onChange={(e)=>handleInputChange(e,3)}
                            onBlur={(e)=>handleInputChange(e,3)}
                            required
                            tabIndex="15"
                            onKeyDown={handleKeyDown}
                            maxLength={3}
                        />
                        {(errors.episodeDuration|| values.episodeDuration === 0) && (
                            <div className='invalidCredential1'>
                                <img className='errorimg1 margin-15px' src={Globals.IMG.ERROR} alt="password error" />
                                <span className="error">{errors.episodeDuration || Globals.UNSOLICITED_ERROR_MSG.INVALID_EPISODE_DURATION}</span>
                            </div>
                        )}
                    </div>
                    <div id="total-duration-holder">
                        <label id="total-duration-label" className="language">
                        {Globals.TOTAL_DURATION}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span>
                        </label>
                        <input
                            type="number"
                            id="totalDuration"
                            className="name-inp width-DropdownSize"
                            value={totalDuration}
                            onChange={(e)=>handleInputChange(e,3)}
                            required
                            disabled
                            style={{background: "#E6E7E8",
                            opacity: "0.7"}}
                            tabIndex="16"
                            onKeyDown={handleKeyDown}
                            maxLength={3}
                        />
                        {errors.totalDuration && (
                            <div className='invalidCredential1'>
                                <img className='errorimg1' src={Globals.IMG.ERROR} alt="password error" />
                                <span className="error">{errors.totalDuration}</span>
                            </div>
                        )}
                    </div>
                </>
            )}
            {formatTypes[format] === "M" && (
                <>
                    <div id="no-of-episodes-holder">
                        <label id="no-of-episodes-label" className="language">
                        {Globals.UNSOLICITED_PROPOSAL.NO_OF_EPISODES}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span>
                        </label>
                        <input
                            type="number"
                            id="noOfMiniEpisodes"
                            className="name-inp width-DropdownSize"
                            value={values.noOfMiniEpisodes}
                            onChange={(e)=>handleInputChange(e,2)}
                            onBlur={(e)=>handleInputChange(e,2)}
                            required
                            tabIndex="14"
                            onKeyDown={handleKeyDown}
                            max={7}
                            maxLength={1}
                        />
                        {((noOfMiniEpisodes>7)||values.noOfMiniEpisodes===0||errors.noOfMiniEpisodes) && (
                            <div className='invalidCredential1'>
                                <img className='errorimg1 margin-15px' src={Globals.IMG.ERROR} alt="password error" />
                                <span className="error">{errors.noOfMiniEpisodes|| Globals.UNSOLICITED_ERROR_MSG.MINI_EPISODES_NOT_IN_RANGE}</span>
                            </div>
                        )}
                    </div>
                    <div id="episode-duration-holder">
                        <label id="episode-duration-label" className="language">
                        {Globals.UNSOLICITED_PROPOSAL.EPISODE_DURATION}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span>
                        </label>
                        <input
                            type="number"
                            id="episodeMiniDuration"
                            className="name-inp width-DropdownSize"
                            value={values.episodeMiniDuration}
                            onChange={(e)=>handleInputChange(e,3)}
                            onBlur={(e)=>handleInputChange(e,3)}
                            required
                            tabIndex="15"
                            onKeyDown={handleKeyDown}
                            maxLength={3}
                        />
                        {(errors.episodeMiniDuration || values.episodeMiniDuration === 0) && (
                            <div className='invalidCredential1'>
                                <img className='errorimg1 margin-15px' src={Globals.IMG.ERROR} alt="password error" />
                                <span className="error">{errors.episodeMiniDuration|| Globals.UNSOLICITED_ERROR_MSG.INVALID_EPISODE_DURATION}</span>
                            </div>
                        )}
                    </div>
                    <div id="total-duration-holder">
                        <label id="total-duration-label" className="language">
                        {Globals.TOTAL_DURATION}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span>
                        </label>
                        <input
                            type="number"
                            id="totalMiniDuration"
                            className="name-inp width-DropdownSize"
                            value={totalMiniDuration}
                            onChange={(e)=>handleInputChange(e,3)}
                            onBlur={(e)=>handleInputChange(e,3)}
                            required
                            disabled
                            tabIndex="16"
                            onKeyDown={handleKeyDown}
                            style={{background: "#E6E7E8",opacity: "0.7"}}
                        />
                        {errors.totalMiniDuration && (
                            <div className='invalidCredential1'>
                                <img className='errorimg1 margin-15px' src={Globals.IMG.ERROR} alt="password error" />
                                <span className="error">{errors.totalMiniDuration}</span>
                            </div>
                        )}
                    </div>
                </>
            )}
                    </div>
                    <div id="proposal-details-row-6" className="row-1-content">
                        <div id="synopsis-holder">
                                <label id="synopsis-label" className="physical-address">{Globals.UNSOLICITED_PROPOSAL.SYNOPSIS}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span>
                                    <CustomTooltip title={Globals.UNSOLICITED_TOOLTIP_SYNOPSIS}>
                                        <img className="infoTooltip" src={infoIcon} alt="Info Icon" />
                                    </CustomTooltip>
                        </label>
                            <TextArea maxCharacters={2500} className="titledDropdownSize1 height-auto" onBlur={handleSynopsisChange} validateField={handleSynopsisChange} key={"synopsis"} value={synopsis}  required tabIndex="17" error={errors.synopsis}/>
                        </div>
                        <div id="logline-holder">
                            <label id="logline-label" className="physical-address">{Globals.UNSOLICITED_PROPOSAL.LOGLINE}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span>
                                    <CustomTooltip title={Globals.UNSOLICITED_TOOLTIP_LOGLINE}>
                                        <img className="infoTooltip" src={infoIcon} alt="Info Icon" />
                                    </CustomTooltip>
                                    </label>
                            <TextArea maxCharacters={1000} className="titledDropdownSize1 height-auto" validateField={logLineChange} onBlur={logLineChange} key={"logline"} value={logline} required tabIndex="18"  error={errors.logline}/>
                        </div>
                    </div>
                    <div id="proposal-details-row-7" className="row-1-content">
                        <div className='flex'>
                            <div id="currency-holder">
                                <label id="currency-label" className="language">{Globals.UNSOLICITED_PROPOSAL.CURRENCY}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                                <span className="comp-titles-list" onBlur={()=>handleCountryChange("currency",currency)}>
                                <DropdownList
                                    selectClass={"currencyDropdownSize "}
                                    dropdowncontainerclass={"apply-brief-dropdown"}
                                    placeHolderValue={''}
                                    options={Currencies}
                                    onSelect={handleDropdownChangeCurrency(setCurrency)}
                                    selectedItem={currency}
                                    // onBlur={() => validateField("currency")}
                                    required
                                    tabIndex="18"
                                    CustomDropdownimg={"unsolicted-img"}
                                />
                                </span>
                                
                                {errors.currency && <div className='invalidCredential1'><img className='errorimg1' src={Globals.IMG.ERROR} alt="password error" /><span className="error">{errors.currency}</span></div>}
                            </div>
                            <div id="target-budget-holder">
                                <label id="target-budget-label" className="physical-address">{Globals.UNSOLICITED_PROPOSAL.TARGET_BUDGET}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                                <input type="text" id="target-budget-input" className="name-inp currencyDropdownSize" value={targetBudget} onChange={handleTargetChange} min="1" step="0.01" onBlur={handleTargetChange} onKeyDown={handleKeyDown} required tabIndex="20" maxLength={15}></input>
                                {errors.targetBudget && <div style={{width:"165px"}} className='invalidCredential1'><img src={Globals.IMG.ERROR} alt="password error" style={{marginTop:"-15px"}}/><span className="error">{errors.targetBudget}</span></div>}
                            </div>
                        </div>
                        
                        <div id="production-schedule-holder" >
                            <label id="production-schedule-label" className="physical-address" style={{width:"350px"}}>{Globals.UNSOLICITED_PROPOSAL.PRODUCTION_SCHEDULE}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <FileUploader onFileRemove={handleFileRemove1} supportedFileType="pdfOrDocOnly" {...(pdfFile?.name && { fileDownload: displayFileNames("PSH") })} onFileUpload={(file)=>handlePdfFile(file)} onBlur={() => {}} required tabIndex="21" checkForValidFile={(flag)=>checkForValidFile(flag)} />
                            {errors.productionSchedule && <div><img className='errorimg1' src={Globals.IMG.ERROR} alt="password error" /><span className="error">{errors.productionSchedule}</span></div>}
                        </div>{
                            isEpisodeStructure &&
                            <div id="episode-structure-outline-holder">
                            <label id="episode-structure-outline-label" className="physical-address">{Globals.UNSOLICITED_PROPOSAL.EPISODE_STRUCTURE_OUTLINE}{isEpisodeStructure && <span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span>}
                                    <CustomTooltip title={Globals.UNSOLICITED_TOOLTIP_EPISODE_ST_OUTLINE}>
                                        <img className="infoTooltip" src={infoIcon} alt="Info Icon" />
                                    </CustomTooltip>
                            </label>
                            <TextArea maxCharacters={2500} className="titledDropdownSize1 height-auto" onBlur={episodeChange} validateField={episodeChange} key={"episodes"} value={episodeStructureOutline} required tabIndex="22"  error={errors.episodeStructureOutline} />
                        </div>
                        }
                        
                    </div>
                    <div id="proposal-details-row-8" className="row-1-content">
                        <div id="location-studio-info-holder">
                            <label id="location-studio-info-label" className="physical-address">{Globals.UNSOLICITED_PROPOSAL.LOCATION_STUDIO_INFO}</label>
                            <TextArea maxCharacters={1000} className="titledDropdownSize1 height-auto" onBlur={locationChange} validateField={locationChange} key={"location"} value={locationStudioInfo} 
                            //  error={errors.locationStudioInfo}
                                // validateField("locationStudioInfo")
                                 required tabIndex="23" />
                        </div>
                        <div id="cast-presenter-info-holder">
                            <label id="cast-presenter-info-label" className="physical-address">{Globals.UNSOLICITED_PROPOSAL.CAST_PRESENTER_INFO}</label>
                            <TextArea maxCharacters={1000} className="titledDropdownSize1 height-auto" value={castPresenterInfo} validateField={castChange} onBlur={castChange} required tabIndex="24"  
                            // error={errors.castPresenterInfo}
                            />
                        </div>
                        <div id="brand-integration-opportunities-holder">
                            <label id="brand-integration-opportunities-label" className="physical-address">{Globals.UNSOLICITED_PROPOSAL.BRAND_INTEGRATION_OPPORTUNITIES}{isBrandIntegrationOpportunities && <span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span>}
                                    <CustomTooltip title={Globals.UNSOLICITED_TOOLTIP_BRAND_INTEGRATION}>
                                        <img className="infoTooltip" src={infoIcon} alt="Info Icon" />
                                    </CustomTooltip>
                            </label>
                            <TextArea maxCharacters={1000} className="titledDropdownSize1 height-auto" validateField={brandChange} onBlur={brandChange}  value={brandIntegrationOpportunities}  error={isBrandIntegrationOpportunities?errors.brandIntegrationOpportunities:''}required />
                        </div>
                    </div>
                    <div id="proposal-details-row-9" className="row-1-content">
                        <div id="project-status-holder">
                            <label id="project-status-label" className="physical-address">{Globals.UNSOLICITED_PROPOSAL.PROJECT_STATUS}
                                {/* <span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span> */}
                                </label>
                            <TextArea maxCharacters={1000} className="titledDropdownSize1 height-auto" textAreaInput={setProjectStatus} value={projectStatus} key={"location"} error={errors.projectStatus} required/>
                        </div>
                        <div id="key-team-holder">
                            <label id="key-team-label" className="physical-address">{Globals.UNSOLICITED_PROPOSAL.KEY_TEAM}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <TextArea maxCharacters={1000} className="titledDropdownSize1 height-auto" validateField={keyTeamChange} onBlur={keyTeamChange} key={"location"}  value={keyTeam}  error={errors.keyTeam} required />
                        </div>
                    </div>
                </div>
                <div id="artist-details-form" className="register-form">
                    <div id="artist-details-form-content" className="register-form-content">
                        <h3 id="artist-details-title" className="basic-info">{Globals.UNSOLICITED_PROPOSAL.MEDIA}</h3>
                        <div id="artist-details-row" className="row-1-content">
                            <div id="artist-name-holder">
                                <label id="artist-name-label" className="physical-address">{Globals.UNSOLICITED_PROPOSAL.ARTIST_NAME}</label>
                                <input type="text" id="artist-name-input" className="name-inp titledDropdownSize1" value={artistName} onChange={(e)=>handleInputChange1(e,setArtistName)} maxLength={100} required></input>
                                {errors.artistName && <span className="error">{errors.artistName}</span>}
                            </div>
                            <div id="song-name-holder">
                                <label id="song-name-label" className="physical-address">{Globals.UNSOLICITED_PROPOSAL.SONG_NAME}</label>
                                <input type="text" id="song-name-input" className="name-inp titledDropdownSize1" value={songName} onChange={(e)=>handleInputChange1(e,setSongName)} maxLength={100} required></input>
                                {errors.songName && <span className="error">{errors.songName}</span>}
                            </div>
                            <div id="video-presentation-holder">
                                <label id="video-presentation-label" className="physical-address" style={{width:"350px"}}>{Globals.UNSOLICITED_PROPOSAL.VIDEO_PRESENTATION}{isMusicVideo && <span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span>}</label>
                                <FileUploader onFileRemove={handleFileRemove2} supportedFileType="VideosOnly" {...(videoFile?.name && { fileDownload: displayFileNames("VP") })} onFileUpload={(file)=>handleVideoFile(file)} required />
                            </div>
                        </div>
                        <div id="social-media-links-holder">
                            <label id="social-media-label" className="social-media">{Globals.UNSOLICITED_PROPOSAL.REFERENCE_LINKS}</label>
                            {socialLinks.map((link, index) => (
                                <div key={index} className="social-media-link">
                                    <input value={link} type="url" id={`social-media-input-${index}`} className="social-media-inp dropdownSize" onChange={(event) => handleSocialMedia(index, event)} onKeyDown={(e) => {
                                        if (e.key === "," || e.key === " ") {
                                            e.preventDefault(); // block comma and space
                                        }
                                    }} required />
                                    {index > 0 && <button
                                        type="button"
                                        className="remove-social-link"
                                        onClick={() => removeSocialLink(index)}
                                    />}
                                    {errors["socialLinks"+index] && <div><img src={Globals.IMG.ERROR} alt="password error" /><span className="error">{errors["socialLinks"+index]}</span></div>}
                                </div>
                            ))}
                            {socialLinks.length < 3 ? <button type="button" id="add-social-link" className={`${localStorage.getItem('lang')!=='en' ? 'add-more-links': 'add-social-link-unsolicited'}`} onClick={addSocialLink}>{Globals.SIGNUP.ADD_MORE_LINKS}</button> :
                                <button type="button" id="add-social-link-disabled" className="add-social-link-disabled" disabled={true}>{Globals.SIGNUP.ADD_MORE_LINKS}</button>}
                        </div>
                    </div>
                </div>
                <div>
                    <UnsolicitedCreateFooter onSaveDraft={handleSaveDraft} isSaveDraftButtonEnabled={isSaveButtonEnabled()} isButtonEnabled={isFormValuesValid && isFileValid!=="invalid"} onSubmit={()=>handleSubmit(false)} onCancelCreate={()=>openPopUp("Abort")} />
                </div>

                {popUpState?.open  && <PopUp
                    onClose={() => setPopUpState({open: false})}
                    text={popUpState.text || ''}
                    title={popUpState.title || ''}
                    negativeAction={popUpState.negativeAction}
                    normalAction={popUpState.normalAction}
                    negativeActionText={popUpState.negativeActionText}
                    normalActionText={popUpState.normalActionText}
                />}
                    {isRegFailed?.visible &&
                
                        <div className='popup-bg'><PopUp title={isRegFailed?.status?Globals.UNSOLICITED_FAILED_SAVE_POPUP_TITLE:Globals.UNSOLICITED_FAILED_POPUP_TITLE}
                            text={Globals.UNSOLICITED_FAILED_POPUP_MESSAGE}
                            normalAction={popUpState.negativeAction}
                            normalActionText={"Retry"}
                            popupType={"failed"}
                            onClose={() => setRegFailure(false)}

                        /></div>}
            </div>}
            {busyLoad && <ProgressLoader height={50} width={50} component={"unsolicated-edit"}/>}
        </div>
    );
}
export default CreateUnsolicited;